import { render, staticRenderFns } from "./TableHeaderCell.vue?vue&type=template&id=60de79a0&scoped=true&"
import script from "./TableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./TableHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./TableHeaderCell.vue?vue&type=style&index=0&id=60de79a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60de79a0",
  null
  
)

export default component.exports